"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersTabContainer = exports.OrdersTab = void 0;
var react_1 = __importDefault(require("react"));
var useOrders_1 = require("../../hook/useOrders");
var messageContext_1 = require("../../hoc/messageContext");
var orders_interface_1 = require("../../interfaces/orders.interface");
var icons_1 = require("@ant-design/icons");
var table_1 = __importDefault(require("antd/es/table"));
var tag_1 = __importDefault(require("antd/es/tag"));
var select_1 = __importDefault(require("antd/es/select"));
var button_1 = __importDefault(require("antd/es/button"));
var popconfirm_1 = __importDefault(require("antd/es/popconfirm"));
var typography_1 = __importDefault(require("antd/es/typography"));
var tabs_1 = __importDefault(require("antd/es/tabs"));
var descriptions_1 = __importDefault(require("antd/es/descriptions"));
var statusColors = {
    Новая: 'blue',
    'В обработке': 'orange',
    Одобрена: 'green',
    Отклонена: 'red',
    Завершена: 'gray',
};
var Title = typography_1.default.Title;
var orderTypeNames = (_a = {},
    _a[orders_interface_1.OrderType.CREDIT] = 'Заявки на кредит',
    _a[orders_interface_1.OrderType.INSTALLMENT] = 'Заявки на рассрочку',
    _a[orders_interface_1.OrderType.CALL_REQUEST] = 'Заявки на обратный звонок',
    _a[orders_interface_1.OrderType.BUYOUT] = 'Заявки на выкуп автомобиля',
    _a[orders_interface_1.OrderType.EXCHANGE] = 'Заявки на обмен автомобиля',
    _a[orders_interface_1.OrderType.CATALOG_ORDER] = 'Заявки на авто из каталога',
    _a);
var OrdersTab = function (_a) {
    var type = _a.type;
    var _b = (0, useOrders_1.useOrders)(type), orders = _b.orders, statuses = _b.statuses, loading = _b.loading, refreshOrders = _b.refreshOrders, updateOrderStatus = _b.updateOrderStatus, deleteOrder = _b.deleteOrder;
    var _c = (0, messageContext_1.useMessageContext)(), showSuccess = _c.showSuccess, showError = _c.showError;
    var sortedOrders = __spreadArray([], orders, true).reverse();
    var handleStatusChange = function (orderId, newStatusId) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateOrderStatus(orderId, newStatusId)];
                case 1:
                    success = _a.sent();
                    if (success) {
                        showSuccess('Статус заявки успешно обновлен');
                        refreshOrders();
                    }
                    else {
                        showError('Ошибка при обновлении статуса');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteOrder = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteOrder(orderId)];
                case 1:
                    _a.sent();
                    showSuccess('Заявка успешно удалена');
                    refreshOrders();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    showError('Ошибка при удалении заявки');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getTypeSpecificColumns = function () {
        switch (type) {
            case orders_interface_1.OrderType.CREDIT:
                return [
                    {
                        title: 'Срок кредита',
                        dataIndex: ['credit', 'credit_term'],
                        key: 'credit_term',
                        render: function (_, record) { var _a; return "".concat((_a = record.credit) === null || _a === void 0 ? void 0 : _a.credit_term, " \u043C\u0435\u0441."); },
                    },
                    {
                        title: 'Первый взнос',
                        dataIndex: ['credit', 'initial_contribution'],
                        key: 'initial_contribution',
                        render: function (_, record) { var _a; return "".concat(Number((_a = record.credit) === null || _a === void 0 ? void 0 : _a.initial_contribution).toLocaleString(), " \u20BD"); },
                    },
                ];
            case orders_interface_1.OrderType.INSTALLMENT:
                return [
                    {
                        title: 'Срок рассрочки',
                        dataIndex: ['installment', 'credit_term'],
                        key: 'credit_term',
                        render: function (_, record) { var _a; return "".concat((_a = record.installment) === null || _a === void 0 ? void 0 : _a.credit_term, " \u043C\u0435\u0441."); },
                    },
                    {
                        title: 'Первый взнос',
                        dataIndex: ['installment', 'initial_contribution'],
                        key: 'initial_contribution',
                        render: function (_, record) { var _a; return "".concat(Number((_a = record.installment) === null || _a === void 0 ? void 0 : _a.initial_contribution).toLocaleString(), " \u20BD"); },
                    },
                ];
            case orders_interface_1.OrderType.CALL_REQUEST:
                return [
                    {
                        title: 'Предпочтительное время',
                        dataIndex: ['call_request', 'preferred_time'],
                        key: 'preferred_time',
                    },
                ];
            case orders_interface_1.OrderType.BUYOUT:
                return [
                    {
                        title: 'Марка',
                        dataIndex: ['buyout', 'brand'],
                        key: 'brand',
                        render: function (_, record) { var _a; return (_a = record.buyout) === null || _a === void 0 ? void 0 : _a.brand; },
                    },
                    {
                        title: 'Модель',
                        dataIndex: ['buyout', 'model'],
                        key: 'model',
                        render: function (_, record) { var _a; return (_a = record.buyout) === null || _a === void 0 ? void 0 : _a.model; },
                    },
                    {
                        title: 'Год выпуска',
                        dataIndex: ['buyout', 'year'],
                        key: 'year',
                        render: function (_, record) { var _a; return (_a = record.buyout) === null || _a === void 0 ? void 0 : _a.year; },
                    },
                    {
                        title: 'Пробег',
                        dataIndex: ['buyout', 'mileage'],
                        key: 'mileage',
                        render: function (_, record) { var _a; return "".concat(Number((_a = record.buyout) === null || _a === void 0 ? void 0 : _a.mileage).toLocaleString(), " \u043A\u043C"); },
                    },
                ];
            case orders_interface_1.OrderType.EXCHANGE:
                return [
                    {
                        title: 'Автомобиль клиента',
                        dataIndex: ['exchange', 'customer_car'],
                        key: 'customer_car',
                    },
                    {
                        title: 'Срок кредита',
                        dataIndex: ['exchange', 'credit_term'],
                        key: 'credit_term',
                        render: function (term) { return "".concat(term, " \u043C\u0435\u0441."); },
                    },
                    {
                        title: 'Первый взнос',
                        dataIndex: ['exchange', 'initial_contribution'],
                        key: 'initial_contribution',
                        render: function (value) { return "".concat(Number(value).toLocaleString(), " \u20BD"); },
                    },
                    {
                        title: 'Выбранный автомобиль',
                        dataIndex: ['exchange', 'car_details'],
                        key: 'car',
                        render: function (carDetails) {
                            return carDetails
                                ? "".concat(carDetails.brand.name, " ").concat(carDetails.model.name, " ").concat(carDetails.year)
                                : 'Не выбран';
                        },
                    },
                ];
            default:
                return [];
        }
    };
    var expandedRowRender = function (record) {
        var _a, _b, _c, _d, _e, _f;
        if (type === orders_interface_1.OrderType.INSTALLMENT) {
            var carDetails = (_a = record[type]) === null || _a === void 0 ? void 0 : _a.car_details;
            return (react_1.default.createElement(descriptions_1.default, { bordered: true, column: 1 },
                react_1.default.createElement(descriptions_1.default.Item, { label: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435" }, carDetails ? (react_1.default.createElement(react_1.default.Fragment, null, "".concat(carDetails.brand.name, " ").concat(carDetails.model.name, " ").concat(carDetails.generation.name, " ").concat(carDetails.year),
                    react_1.default.createElement("br", null), "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F: ".concat(carDetails.complectation_name),
                    react_1.default.createElement("br", null), "\u0414\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C: ".concat(carDetails.engine_capacity_type.capacity, "\u043B. ").concat(carDetails.engine_name_type.name, " (").concat(carDetails.engine_power_type.power, " \u043B.\u0441.)"),
                    react_1.default.createElement("br", null), "\u041A\u041F\u041F: ".concat(carDetails.gearbox_type.name),
                    react_1.default.createElement("br", null), "\u041F\u0440\u0438\u0432\u043E\u0434: ".concat(carDetails.drive_type.name),
                    react_1.default.createElement("br", null), "\u0426\u0432\u0435\u0442: ".concat(carDetails.color.name),
                    react_1.default.createElement("br", null), "\u0426\u0435\u043D\u0430: ".concat(Number(carDetails.price).toLocaleString(), " \u20BD"))) : ('Автомобиль не выбран'))));
        }
        if (type === orders_interface_1.OrderType.EXCHANGE) {
            var carDetails = (_b = record[type]) === null || _b === void 0 ? void 0 : _b.car_details;
            return (react_1.default.createElement(descriptions_1.default, { bordered: true, column: 1 },
                react_1.default.createElement(descriptions_1.default.Item, { label: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0436\u0435\u043B\u0430\u0435\u043C\u043E\u043C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435" }, carDetails ? (react_1.default.createElement(react_1.default.Fragment, null, "".concat(carDetails.brand.name, " ").concat(carDetails.model.name, " ").concat(carDetails.generation.name, " ").concat(carDetails.year),
                    react_1.default.createElement("br", null), "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F: ".concat(carDetails.complectation_name),
                    react_1.default.createElement("br", null), "\u0414\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C: ".concat(carDetails.engine_capacity_type.capacity, "\u043B. ").concat(carDetails.engine_name_type.name, " (").concat(carDetails.engine_power_type.power, " \u043B.\u0441.)"),
                    react_1.default.createElement("br", null), "\u041A\u041F\u041F: ".concat(carDetails.gearbox_type.name),
                    react_1.default.createElement("br", null), "\u041F\u0440\u0438\u0432\u043E\u0434: ".concat(carDetails.drive_type.name),
                    react_1.default.createElement("br", null), "\u0426\u0432\u0435\u0442: ".concat(carDetails.color.name),
                    react_1.default.createElement("br", null), "\u0426\u0435\u043D\u0430: ".concat(Number(carDetails.price).toLocaleString(), " \u20BD"))) : ('Автомобиль не выбран')),
                react_1.default.createElement(descriptions_1.default.Item, { label: "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430" }, ((_c = record[type]) === null || _c === void 0 ? void 0 : _c.customer_car) || 'Не указан'),
                react_1.default.createElement(descriptions_1.default.Item, { label: "\u041F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441" }, ((_d = record[type]) === null || _d === void 0 ? void 0 : _d.initial_contribution)
                    ? "".concat(Number(record[type].initial_contribution).toLocaleString(), " \u20BD")
                    : 'Не указан'),
                react_1.default.createElement(descriptions_1.default.Item, { label: "\u0421\u0440\u043E\u043A \u043A\u0440\u0435\u0434\u0438\u0442\u0430" }, ((_e = record[type]) === null || _e === void 0 ? void 0 : _e.credit_term) ? "".concat(record[type].credit_term, " \u043C\u0435\u0441.") : 'Не указан')));
        }
        var carDetails = (_f = record[type]) === null || _f === void 0 ? void 0 : _f.car_details;
        var bank = record.bank;
        var program = record.program;
        return (react_1.default.createElement(descriptions_1.default, { bordered: true, column: 1 },
            react_1.default.createElement(descriptions_1.default.Item, { label: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435" }, carDetails ? (react_1.default.createElement(react_1.default.Fragment, null, "".concat(carDetails.brand.name, " ").concat(carDetails.model.name, " ").concat(carDetails.generation.name, " ").concat(carDetails.year),
                react_1.default.createElement("br", null), "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F: ".concat(carDetails.complectation_name),
                react_1.default.createElement("br", null), "\u0414\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C: ".concat(carDetails.engine_capacity_type.capacity, "\u043B. ").concat(carDetails.engine_name_type.name, " (").concat(carDetails.engine_power_type.power, " \u043B.\u0441.)"),
                react_1.default.createElement("br", null), "\u041A\u041F\u041F: ".concat(carDetails.gearbox_type.name),
                react_1.default.createElement("br", null), "\u041F\u0440\u0438\u0432\u043E\u0434: ".concat(carDetails.drive_type.name),
                react_1.default.createElement("br", null), "\u0426\u0432\u0435\u0442: ".concat(carDetails.color.name),
                react_1.default.createElement("br", null), "\u0426\u0435\u043D\u0430: ".concat(Number(carDetails.price).toLocaleString(), " \u20BD"))) : ('Автомобиль не выбран')),
            react_1.default.createElement(descriptions_1.default.Item, { label: "\u0411\u0430\u043D\u043A" }, bank ? bank.name : 'Банк не выбран'),
            react_1.default.createElement(descriptions_1.default.Item, { label: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430" }, program ? program.name : 'Программа не выбрана')));
    };
    var getColumns = function () { return __spreadArray(__spreadArray([
        {
            title: 'ID',
            dataIndex: type === orders_interface_1.OrderType.CATALOG_ORDER ? 'order_id' : 'id',
            key: 'id',
            width: 80,
            sorter: function (a, b) { return b.id - a.id; },
        },
        {
            title: 'Имя клиента',
            dataIndex: type === orders_interface_1.OrderType.CATALOG_ORDER ? 'customer_name' : [type, 'name'],
            key: 'name',
            render: function (_, record) { var _a; return type === orders_interface_1.OrderType.CATALOG_ORDER ? record.customer_name : (_a = record[type]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            title: 'Телефон',
            dataIndex: type === orders_interface_1.OrderType.CATALOG_ORDER ? 'customer_phone' : [type, 'name'],
            key: 'phone',
            render: function (_, record) { var _a; return type === orders_interface_1.OrderType.CATALOG_ORDER ? record.customer_phone : (_a = record[type]) === null || _a === void 0 ? void 0 : _a.phone; },
        }
    ], getTypeSpecificColumns(), true), [
        {
            title: 'Стаус',
            key: 'status',
            render: function (_, record) { return (react_1.default.createElement(select_1.default, { value: record.order_status.id, onChange: function (value) {
                    return handleStatusChange(type === orders_interface_1.OrderType.CATALOG_ORDER ? record.order_id : record.id, value);
                }, style: { width: 150 } }, statuses.map(function (status) { return (react_1.default.createElement(select_1.default.Option, { key: status.id, value: status.id },
                react_1.default.createElement(tag_1.default, { color: statusColors[status.name] }, status.name))); }))); },
        },
        {
            title: 'Действия',
            key: 'actions',
            width: 100,
            render: function (_, record) { return (react_1.default.createElement(popconfirm_1.default, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443?", description: "\u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C", onConfirm: function () { return handleDeleteOrder(type === orders_interface_1.OrderType.CATALOG_ORDER ? record.order_id : record.id); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                react_1.default.createElement(button_1.default, { type: "link", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null) }))); },
        },
    ], false); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Title, { level: 3, style: { marginBottom: 24 } }, orderTypeNames[type]),
        react_1.default.createElement(table_1.default, { dataSource: sortedOrders, columns: getColumns(), rowKey: "id", loading: loading, expandable: {
                expandedRowRender: expandedRowRender,
                rowExpandable: function () { return [orders_interface_1.OrderType.CREDIT, orders_interface_1.OrderType.INSTALLMENT, orders_interface_1.OrderType.EXCHANGE].includes(type); },
            }, pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E: ".concat(total, " \u0437\u0430\u043F\u0438\u0441\u0435\u0439"); },
                defaultCurrent: 1,
            } })));
};
exports.OrdersTab = OrdersTab;
var tabItems = [
    {
        key: orders_interface_1.OrderType.CREDIT,
        label: 'Кредиты',
        children: react_1.default.createElement(exports.OrdersTab, { type: orders_interface_1.OrderType.CREDIT }),
    },
    {
        key: orders_interface_1.OrderType.INSTALLMENT,
        label: 'Рассрочка',
        children: react_1.default.createElement(exports.OrdersTab, { type: orders_interface_1.OrderType.INSTALLMENT }),
    },
    {
        key: orders_interface_1.OrderType.CALL_REQUEST,
        label: 'Обратные звонки',
        children: react_1.default.createElement(exports.OrdersTab, { type: orders_interface_1.OrderType.CALL_REQUEST }),
    },
    {
        key: orders_interface_1.OrderType.BUYOUT,
        label: 'Выкуп авто',
        children: react_1.default.createElement(exports.OrdersTab, { type: orders_interface_1.OrderType.BUYOUT }),
    },
    {
        key: orders_interface_1.OrderType.EXCHANGE,
        label: 'Обмен авто',
        children: react_1.default.createElement(exports.OrdersTab, { type: orders_interface_1.OrderType.EXCHANGE }),
    },
];
var OrdersTabContainer = function () {
    return react_1.default.createElement(tabs_1.default, { items: tabItems });
};
exports.OrdersTabContainer = OrdersTabContainer;
